import { AssetReference } from "@kosmod/assets";
import { K3D } from "@kosmod/graphics-3d";
import { ID, idDef } from "@kosmod/kit";
import { s } from "@kosmod/pancake";
import { GameID } from "@kosmod/sesame";

export type MiniSpriteID = ID<'mini-sprite'>;
export const MiniSpriteID = s.ref<MiniSpriteID>()(idDef);

export type MiniSprite = {
  id: MiniSpriteID,
  game: GameID,
  imageAsset: AssetReference,
  /**
   * A box in the sprite image asset (as a unit square(1x1))
   * that contains the actual render-able portion. If null,
   * use the whole image.
   */
  imageArea: null | K3D.Box2,
};
export const MiniSprite = s.ref<MiniSprite>()(s.o({
  id: MiniSpriteID,
  game: GameID,
  imageAsset: AssetReference,
  imageArea: s.optional(K3D.Box2),
}));

export type MiniModelID = ID<'mini-model'>;
export const MiniModelID = s.ref<MiniModelID>()(idDef);

export type MiniModel = {
  id: MiniModelID,
  game: GameID,
  modelAsset: AssetReference,
  modelPath: string[],
}
export const MiniModel = s.ref<MiniModel>()(s.o({
  id: MiniModelID,
  game: GameID,
  modelAsset: AssetReference,
  modelPath: s.a(s.str),
}));